const weeks = [
  { title: "Week 1-2", topics: ["C++ setup", "Data types", "Conditionals and loops"] },
  { title: "Week 3-4", topics: ["Functions", "Arrays", "Strings", "Pointers"] },
  { title: "Week 5", topics: ["Big O", "Fast I/O"] },
  { title: "Week 6", topics: ["GCD/LCM", "Prime and sieve"] },
  { title: "Week 7-8", topics: ["Prefix sum", "Two pointers", "Sliding window"] },
  { title: "Week 9-10", topics: ["Vector", "Map/Set", "Stack/Queue"] },
  { title: "Week 11-12", topics: ["Sorting", "Binary search", "Applications"] },
];

const Syllabus = () => {
  return (
    <section className="home-section">
      <div className="home-container">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-3">
          <div>
            <span className="section-kicker">Beginner Syllabus</span>
            <h2 className="home-title mt-4 text-2xl font-bold sm:text-4xl">
              A 12-week path from basics to <span className="home-accent-gradient">problem-solving confidence</span>
            </h2>
          </div>
          <p className="max-w-md text-sm home-muted">
            Includes weekly marathon practice, on-site contests, and discussion sessions.
          </p>
        </div>

        <div className="grid home-stagger-grid gap-4 xl:grid-cols-4">
          <article className="home-card-strong p-6 xl:col-span-1">
            <h3 className="text-lg font-semibold">Practice Format</h3>
            <ul className="mt-4 space-y-3 text-sm home-muted">
              <li className="home-card px-3 py-2">Weekly online marathon contest</li>
              <li className="home-card px-3 py-2">Onsite practice every two weeks</li>
              <li className="home-card px-3 py-2">Post-contest discussion sessions</li>
            </ul>
          </article>

          <div className="grid home-stagger-grid gap-3 sm:grid-cols-2 xl:col-span-3">
            {weeks.map((week) => (
              <article key={week.title} className="home-card p-5">
                <h3 className="text-base font-semibold home-accent">{week.title}</h3>
                <ul className="mt-3 space-y-2 text-sm home-muted">
                  {week.topics.map((topic) => (
                    <li key={topic} className="home-card-strong px-3 py-2">
                      {topic}
                    </li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Syllabus;
